import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ErrorModel } from 'src/app/core/models/error.model';
import { LocalStorage } from 'src/app/core/utils/local.storage';
import { DialogService } from 'src/app/layout/services/dialog.service';
import { FavoritoModel } from 'src/app/main/hao/models/favorito.model';
import { HeadhunterModel } from 'src/app/main/headhunter/models/headhunter.model';
import { FavoritoService } from '../../services/favorito.service';

@Component({
  selector: 'app-list-phh',
  templateUrl: './list-phh.component.html',
  styleUrls: ['./list-phh.component.scss']
})
export class ListPhhComponent implements OnInit {

  displayedColumns: string[] = [
    'favorito','foto','candidato','mercado','cargo','senioridade','disponibilidadeGeografica','status','contatos'
  ];
  loading = false;
  dataSource = new MatTableDataSource<HeadhunterModel>();
  pageSize = 10;
  pageRanger = [2, 10, 20, 50];
  allFavorite: FavoritoModel[] = [];
  private auth: any = LocalStorage.getItem('usuario');
  userProfile = this.auth.userProfile;

  constructor(
      private dialogService: DialogService,
      private favoritoService: FavoritoService,
      private router: Router,
  ) { }

  ngOnInit(): void {
    this.loadFavorites();
  }

  clickNavigation(s: string): void {
    this.router.navigate([s]);
  }

  loadFavorites(): void {
    this.loading = true
    this.favoritoService.getFavoriteHeadhunter().subscribe(result => {
      this.dataSource = new MatTableDataSource<HeadhunterModel>(result);
    }, (error: ErrorModel) => {
      const msgErro = 'Erro ao carregar favoritos do servidor';
      this.dialogService.showAlert(msgErro);
    }).add(() => {
      this.loading = false;
    });
  }

  removeFavorito(codigo: string) {
    this.favoritoService.remove(Number(codigo)).subscribe(results => {
    }, (error: ErrorModel) => {
      console.log(error);
    });
  }

  addFavorito(codigo: string, pipeId: any) {
    this.favoritoService.add({cardId: codigo, pipeId: pipeId}).subscribe(results => {
    }, (error: ErrorModel) => {
      console.log(error);
    });
  }

}
